import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useEmployeeShiftUnbookings = ({ employeeId }) => {
  const { accountId } = useAccount();

  const storeKey = ['employeeShiftUnbookings', accountId, employeeId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchEmployeeShiftUnbookings({ accountId, employeeId }), {
    staleTime: 0
  });

  return { isLoading, unbookingShifts: data?.data || [] };
};

export default useEmployeeShiftUnbookings;
